import s from './index.module.css'
import React, { useEffect, useRef } from 'react'
import { Helmet } from 'react-helmet'
import { useDispatch, useSelector } from 'react-redux'
import { setTheme } from '~local/actions'

import Header from './header'
import Dialog from '~co/overlay/dialog'

export default function ScreenBasic({
    className = '',
    children,
    appSize,
    ...etc
}) {
    const dispatch = useDispatch()
    const rehydrated = useSelector(state => state._persist.rehydrated)
    const theme = useSelector(state => state.local.theme)
    const storeAppSize = useSelector(state => state.local.appSize)
    const appSizeFinal = appSize || storeAppSize

    const latest = useRef({ rehydrated, theme, dispatch })
    latest.current = { rehydrated, theme, dispatch }

    useEffect(() => {
        const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)')

        const onPrefersColorSchemeChange = e => {
            const app = e.matches ? 'night' : 'day'
            const { rehydrated, theme, dispatch } = latest.current

            if (rehydrated)
                if (theme.auto || (theme.app == app && theme.sidebar == app))
                    dispatch(setTheme({ app, sidebar: app, auto: true }))
        }

        onPrefersColorSchemeChange(darkModeMediaQuery)
        darkModeMediaQuery.addListener(onPrefersColorSchemeChange)
        return () => darkModeMediaQuery.removeListener(onPrefersColorSchemeChange)
    }, [])

    return (
        <>
            <Helmet defer={false}>
                <html
                    data-theme={theme.app}
                    data-app-size={appSizeFinal} />
                <meta name='theme-color' content={theme.app == 'night' ? '#2A2B2D' : '#FFFFFF'} />
            </Helmet>

            <div
                {...etc}
                data-is-page
                className={s.page + ' ' + className}>
                {children}

                <Dialog />
            </div>
        </>
    )
}

export { Header }
